import type { FC, PropsWithChildren } from "react";

/** Shared two-column shell for Login/Register/Reset Password: branding panel + form card. */
const AuthShell: FC<PropsWithChildren> = ({ children }) => (
    <main id="auth-shell">
        <div className="auth-shell__brand">
            <p className="auth-shell__eyebrow">Shopfront Developers</p>
            <h1>Build something brilliant.</h1>
            <p className="auth-shell__subhead">
                Register applications, call the Shopfront API, and ship integrations that stores love.
            </p>
        </div>
        <div className="auth-shell__form">
            {children}
        </div>
    </main>
);

export default AuthShell;
